'use client';

import { FilloutStandardEmbed } from '@fillout/react';
import { Container } from '@mv/web-ui';
import type { FilloutEmbedBlock as Props } from '@/payload/types';

const FILLOUT_DOMAIN = 'forms.mobilevikings.be';

export default function FilloutEmbed({ filloutId }: Props) {
	// Trim whitespace from filloutId and check if empty
	const id = filloutId?.trim() ?? '';

	if (!id) return null;

	return (
		<Container data-component="FilloutEmbedBlock">
			<FilloutStandardEmbed filloutId={id} dynamicResize={true} domain={FILLOUT_DOMAIN} />
		</Container>
	);
}
